import { Skeleton } from '@/components/ui/skeleton'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Building2, User, Truck } from 'lucide-react';

const DetailSkeleton = () => {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 min-h-[350px]">
            <Card>
                <CardHeader className="pb-2">
                    <CardTitle className="flex items-center text-lg">
                        <Building2 className="w-5 h-5 mr-2" />
                        Fornecedor
                    </CardTitle>
                </CardHeader>
                <CardContent>
                    <dl className="space-y-2">
                        <dt className="text-sm font-medium text-muted-foreground">Nome Fantasia</dt>
                        <Skeleton className="md:col-span-2 h-[22px]  bg-gray-300" />
                        <dt className="text-sm font-medium text-muted-foreground">CNPJ</dt>
                        <Skeleton className="md:col-span-2 h-[22px]  bg-gray-300" />
                    </dl>
                </CardContent>
            </Card>

            <Card>
                <CardHeader className="pb-2">
                    <CardTitle className="flex items-center text-lg">
                        <User className="w-5 h-5 mr-2" />
                        Cliente
                    </CardTitle>
                </CardHeader>
                <CardContent>
                    <dl className="space-y-2">
                        <dt className="text-sm font-medium text-muted-foreground">Nome Fantasia</dt>
                        <Skeleton className="md:col-span-2 h-[22px]  bg-gray-300" />
                        <dt className="text-sm font-medium text-muted-foreground">CNPJ</dt>
                        <Skeleton className="md:col-span-2 h-[22px]  bg-gray-300" />
                    </dl>
                </CardContent>
            </Card>

            <Card >
                <CardHeader className="pb-2">
                    <CardTitle className="flex items-center text-lg">
                        <Truck className="w-5 h-5 mr-2" />
                        Fornecedor
                    </CardTitle>
                </CardHeader>
                <CardContent>
                    <dl className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <dt className="text-sm font-medium text-muted-foreground">Nome Fantasia</dt>
                            <Skeleton className="md:col-span-2 h-[22px]  bg-gray-300" />
                        </div>
                        <div>
                            <dt className="text-sm font-medium text-muted-foreground">CNPJ</dt>
                            <Skeleton className="md:col-span-2 h-[22px]  bg-gray-300" />
                        </div>
                    </dl>
                </CardContent>
            </Card>

            <Card>
                <CardHeader className="pb-2">
                    <CardTitle className="flex items-center text-lg">
                        Reconhecimento
                    </CardTitle>
                </CardHeader>
                <CardContent>
                    <Skeleton className="md:col-span-2 h-[22px]  bg-gray-300" />
                </CardContent>
            </Card>
        </div>
    )
}


export default DetailSkeleton
